export class ManufacturerFilterSettingsModel {
  public name: string;
  public country: string;
  public alphaIndex: string;
}